export default __webpack_public_path__ + "static/media/tavisca.e125e6f2.jpeg";